export default __webpack_public_path__ + "static/Paweł Paczuski-285625ccfd00d7d01539b552b949f5c1.jpg";